/**
 * Hostname label for a hosted app: <slug>.apps.<domain>.
 * SLUG_MIN = 3 also keeps "--" out of hostname positions 3-4 (reserved by RFC 5890 for IDNA), which a
 * 2-character slug followed by PREVIEW_SUFFIX would otherwise violate.
 */
export const SLUG_MIN = 3;
export const SLUG_MAX = 40;
export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
/** Labels we never hand out because they collide with platform hostnames or read as official. */
export const RESERVED_SLUGS = new Set([
    'console',
    'api',
    'www',
    'origin',
    'apps',
    'app',
    'admin',
    'auth',
    'login',
    'xero',
    'static',
    'cdn',
    'mail',
    'smtp',
    'ns',
    'ns1',
    'ns2',
    'status',
    'help',
    'support',
    'docs',
    'dev',
    'test',
    'prod',
]);
export function checkSlug(input) {
    const slug = input.trim().toLowerCase();
    if (slug.length < SLUG_MIN)
        return { ok: false, reason: `at least ${SLUG_MIN} characters` };
    if (slug.length > SLUG_MAX)
        return { ok: false, reason: `at most ${SLUG_MAX} characters` };
    if (!SLUG_PATTERN.test(slug))
        return { ok: false, reason: 'lower-case letters, digits and hyphens only' };
    if (slug.includes('--'))
        return { ok: false, reason: 'no consecutive hyphens' };
    if (RESERVED_SLUGS.has(slug))
        return { ok: false, reason: 'that name is reserved' };
    return { ok: true, slug };
}
/** Derive a slug suggestion from a display name. */
export function slugify(name) {
    return name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, SLUG_MAX);
}
/**
 * Builder preview hosts are <slug>--preview.apps.<domain>. checkSlug() rejects consecutive hyphens, so a
 * preview label can never collide with a real app; the edge function treats it like any other label.
 */
export const PREVIEW_SUFFIX = '--preview';
export function previewLabel(slug) {
    return `${slug}${PREVIEW_SUFFIX}`;
}
/** Split a hostname label into the app slug and whether it is the builder preview. */
export function parseAppLabel(label) {
    const preview = label.endsWith(PREVIEW_SUFFIX);
    const slug = preview ? label.slice(0, -PREVIEW_SUFFIX.length) : label;
    const check = checkSlug(slug);
    if (!check.ok || check.slug !== slug)
        return undefined;
    return { slug, preview };
}
export function appHost(slug, domain) {
    return `${slug}.apps.${domain}`;
}
export function consoleHost(domain) {
    return `console.${domain}`;
}
//# sourceMappingURL=slug.js.map